import $ from 'jquery'
import { createAlert } from '../../dom/window'
import _ from 'lodash'
import config from '../../store/_config'
import { axiosInstance as axios, handleAxiosErrors, breakListIntoChunks } from '_utils'
import {
  convertProductMaintenanceDetailsToReact,
  convertProductMaintenanceDetailImagesToReact,
  convertProductMaintenanceDetailToPost,
} from '../../selectors/converterSelectors'
import {
  convertFrontlineProductsPricesToAReadableFormat,
  convertProductsListingToAReadableFormat,
  convertProductListingCategories,
} from '../../selectors/productSelectors'
import { requestCategoryNames, updateCategories } from '../../actions/productsActions'
import { axiosRequestProductList } from './threePlProductSupplierActions'
import { axiosUploadImages } from './imageActions'

export const toggleLoading = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_THREE_PL_CUSTOMER_LOADING',
      key: key,
      value: value,
    })
  }
}

export const requestProductMaintenanceList = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const params = {
      startingIndex: 0,
      perPage: 10000, //for fetching all records of search
      amount: 300,
    }

    // dispatch(toggleLoading('list', true))
    return axiosRequestProductList(state, params)
      .then((response) => {
        if (typeof response?.data?.data?.searchResult != 'undefined') {
          const products = convertProductsListingToAReadableFormat(
            response?.data?.data?.searchResult?.edges,
            state.user
          )
          const categories = convertProductListingCategories(response?.data?.data?.searchResult?.edges, state.user) // NOTE: this was removed from the query on 18/12

          // Get product IDs to request price
          const productIDs = products.map((item) => item.productID) // Uncomment this if you need to show price

          // wait for async requests
          Promise.all([
            dispatch(updateProductMaintenanceList(products)),
            //dispatch(updateCategories(categories)),
            // Joey commented it for testing
            //dispatch(requestProductsPrices(productIDs)), // Uncomment this if you need to show price
          ]).then(() => {
            //dispatch(requestCategoryNames(Object.keys(categories)));
            dispatch(toggleLoading('list', false))
          })
        } else {
          dispatch(toggleLoading('list', false))
          createAlert({}, 'bad')
        }
      })
      .catch((error) => {
        dispatch(toggleLoading('list', false))
        handleAxiosErrors(error)
      })
  }
}

export const requestProductsPrices = (list) => {
  return (dispatch, getState) => {
    const chunkedList = breakListIntoChunks(list, 900)

    chunkedList.map((chunkedProductIDs) => {
      const state = getState()

      axiosRequestFrontlineProductsPrices(state, chunkedProductIDs)
        .then((response) => {
          const { data } = response
          const products = convertFrontlineProductsPricesToAReadableFormat(
            data,
            state.user,
            state.productMaintenance.list
          )
          dispatch(updateProductMaintenanceList(products))
        })
        .catch((error) => handleAxiosErrors(error))
    })
  }
}

export const axiosRequestFrontlineProductsPrices = (state, chunkedProductIDs) => {
  const { key } = state.user

  let { url } = config.products.frontlinePricesSupplier
  url = url.replace('{productIDs}', chunkedProductIDs.join('_'))

  return axios
    .get(url, {
      withCredentials: true,
      headers: {
        Authorization: key,
      },
    })
    .catch((error) => handleAxiosErrors(error))
}

export const getDefaultProductMaintenanceDetails = (productID) => {
  return {
    isRemove: false,
    title: '',
    description: '',
    supplierid: 0,
    supplierProductNum: '',
    Name: '',
    productid: productID,
    productType: '',
    country: '',
    region: '',
    style: '',
    varietals: '',
    additionalNote: '',
    size: '',
    alcoholStrength: '',
    unitsPerRetailPack: '',
    unitsPerCarton: '',
    unitType: '',
    cartonWeight: '',
    singleBarcode: '',
    retailBarcode: '',
    cartonBarcode: '',
    dimensionHeight: '',
    dimensionWidth: '',
    dimensionLength: '',
    casesPerPallet: '',
    casesPerLayer: '',
    gstApplicable: false,
    wetApplicable: false,
    frontLinePrice: 0.0,
    invoiceAllowanceType: '',
    invoiceAllowance: '',
    netInvoicePrice: '',
    nswDepositLevy: 0.0,
    saDepositLevy: 0.0,
    soldByCaseOnly: 0,
    images: [],
    removedImages: [],
    acceptedFiles: [],
    rejectedFiles: [],
    MarketingTag: '',
    TrackVintages: false,
  }
}

export const loadProductMaintenanceDetails = (id) => {
  return (dispatch, getState) => {
    const state = getState()
    //const productMaintenanceModal = document.getElementById('edit-product-modal');
    const productMaintenanceList = state.productMaintenance.list
    const productMaintenanceItem = productMaintenanceList[id]
    const productMaintenanceDetail = state.productMaintenance.detail
    let { productID, case_price, sku } = productMaintenanceItem

    const baseData = {
      productid: productID,
      supplierid: window.supplierID,
      paramountproductid: sku,
      frontLinePrice: case_price,
    }

    let { url, query } = config.productMaintenance.detail
    query = query.replace('{ProductID}', productID)

    if (!(productMaintenanceDetail && productMaintenanceDetail.productid == productID)) {
      dispatch(toggleLoading('modal', true))
      axios
        .get(url, {
          params: {
            query: query,
          },
        })
        .then((response) => {
          if (typeof response.data.data != 'undefined') {
            const list = convertProductMaintenanceDetailsToReact(response?.data?.data, baseData)

            let detail = list.length > 0 ? list.pop() : getDefaultProductMaintenanceDetails(id)

            // update frontLinePrice
            if (detail.frontLinePrice <= 0) {
              detail.frontLinePrice = case_price
            }

            dispatch(updateProductMaintenanceDetails(detail))
            dispatch(toggleLoading('modal', false))
          } else {
            if (typeof response.errors != 'undefined') {
              createAlert(response.errors[0], 'error')
            }

            console.log('Invalid response')
            //$(productMaintenanceModal).modal('hide');
          }
        })
        .catch((error) => handleAxiosErrors(error))
    }
  }
}

export const loadProductMaintenanceDetailImages = () => {
  return (dispatch, getState) => {
    const state = getState()
    const productID = state.productMaintenance.detail.productID
    let { url, query } = config.productMaintenance.detailImages
    query = query.replace('{supplierID}', window.supplierID).replace('{productID}', productID)

    axios
      .get(url, {
        params: {
          query: query,
        },
        withCredentials: true,
      })
      .then((response) => {
        if (typeof response.data.data != 'undefined') {
          const list = convertProductMaintenanceDetailImagesToReact(response.data.data)

          if (list.length > 0) {
            const detail = list.pop()
            dispatch(updateProductMaintenanceDetails(detail))
          }
        } else {
          if (typeof response.errors != 'undefined') {
            createAlert(response.errors[0], 'error')
          }
        }
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

// Create post for product maintenance (add)
export const postProductMaintenance = (postData) => {
  return async (dispatch, getState) => {
    const ProductID = postData?.['productid'] ? parseInt(postData?.['productid'], 10) : 0
    const acceptedFiles = postData?.acceptedFiles

    dispatch(toggleLoading('form', true))
    //dispatch(toggleLoading(false));

    let images = []
    if (acceptedFiles?.length) {
      try {
        images = await Promise.all(
          acceptedFiles.map(async (file) => {
            return await axiosUploadImages(file)
          })
        )
      } catch (error) {
        dispatch(toggleLoading('form', false))
        return handleAxiosErrors(error)
      }
    }

    postData = convertProductMaintenanceDetailToPost({
      ...postData,
      images,
    })

    const { url, query } = config.productMaintenance.update

    try {
      const response = await axios.post(url, {
        query,
        variables: {
          ProductID,
          Input: postData,
        },
      })

      if (response?.data?.data?.createProductMaintenanceRequest) {
        // $('#edit-product-modal').modal('hide');
        // $('#add-product-modal').modal('hide');

        dispatch(requestProductMaintenanceList())
        dispatch(updateProductMaintenanceDetails({}))
        dispatch(resetProductMaintenanceDetails())

        createAlert(
          {
            message: 'Success',
          },
          'success'
        )
      } else {
        createAlert({}, 'error')
      }

      dispatch(toggleLoading('form', false))
    } catch (error) {
      dispatch(toggleLoading('form', false))
      return handleAxiosErrors(error)
    }
  }
}

export const removeProductMaintenanceImage = (id, imageID) => {
  return (dispatch, getState) => {
    let { url } = config.productMaintenance.removeImage

    if (id && imageID) {
      axios
        .get(url, {
          params: {
            id: id,
            imageid: imageID,
          },
          withCredentials: true,
        })
        .then((response) => {
          //dispatch(toggleLoading(false));
          const { data } = response

          if (typeof data.status != 'undefined' && data.status) {
            dispatch(loadProductMaintenanceDetailImages())

            if (typeof data.message != 'undefined') {
              createAlert(data, 'success')
            }
          } else {
            createAlert({}, 'error')
          }
        })
        .catch((error) => handleAxiosErrors(error))
    }
  }
}

export const updateProductMaintenanceList = (list) => {
  return {
    type: 'UPDATE_THREE_PL_PRODUCT_MAINTENANCE_LIST',
    list: _.keyBy(list, 'id'),
  }
}

export const updateProductMaintenanceDetails = (detail) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_THREE_PL_PRODUCT_MAINTENANCE_DETAIL',
      detail: detail,
    })

    if (detail.netInvoicePrice == 0) {
      dispatch(adjustInvoiceAllowance('invoiceAllowance', 'edit'))
    }
  }
}

export const changeProductMaintenanceDetails = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_THREE_PL_PRODUCT_MAINTENANCE_DETAIL',
      key: key,
      value: value,
    })

    dispatch(adjustInvoiceAllowance(key, 'edit'))
  }
}

export const changeProductMaintenanceDetailsBulk = (values) => {
  return {
    type: 'CHANGE_THREE_PL_PRODUCT_MAINTENANCE_DETAIL_BULK',
    values: values,
  }
}

export const changeProductMaintenanceAddDetails = (key, value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'CHANGE_THREE_PL_PRODUCT_MAINTENANCE_NEW_FORM',
      key: key,
      value: value,
    })

    dispatch(adjustInvoiceAllowance(key, 'add'))
  }
}

export const changeProductMaintenanceAddDetailsBulk = (values) => {
  return {
    type: 'CHANGE_THREE_PL_PRODUCT_MAINTENANCE_NEW_FORM_BULK',
    values: values,
  }
}

export const resetProductMaintenanceDetails = (values) => {
  return {
    type: 'RESET_THREE_PL_PRODUCT_MAINTENANCE_NEW_FORM_BULK',
    values: values,
  }
}

export const adjustInvoiceAllowance = (key, type) => {
  return (dispatch, getState) => {
    if (key == 'invoiceAllowance' || key == 'invoiceAllowanceType' || key == 'frontLinePrice') {
      const isEdit = typeof type != 'undefined' && type == 'edit'
      const state = getState()
      const detail = isEdit ? state.productMaintenance.detail : state.productMaintenance.newForm
      const { invoiceAllowanceType, frontLinePrice } = detail
      let { invoiceAllowance } = detail

      let calculatedNetInvoicePrice = frontLinePrice

      // Check min
      if (invoiceAllowance < 0) {
        invoiceAllowance = 0
      }

      // Check depending on value
      if (invoiceAllowanceType == 'Amount') {
        // Check max for fixed
        if (invoiceAllowance > frontLinePrice) {
          invoiceAllowance = frontLinePrice
        }

        calculatedNetInvoicePrice = frontLinePrice - invoiceAllowance
      } else {
        // Check max for percentage
        if (invoiceAllowance > 100) {
          invoiceAllowance = 100
        }

        calculatedNetInvoicePrice = frontLinePrice - (frontLinePrice * invoiceAllowance) / 100
      }

      // Rounding
      calculatedNetInvoicePrice = Math.round(calculatedNetInvoicePrice * 100) / 100

      // And update
      if (isEdit) {
        dispatch(
          changeProductMaintenanceDetailsBulk({
            invoiceAllowance: invoiceAllowance,
            netInvoicePrice: calculatedNetInvoicePrice,
          })
        )
      } else {
        dispatch(
          changeProductMaintenanceAddDetailsBulk({
            invoiceAllowance: invoiceAllowance,
            netInvoicePrice: calculatedNetInvoicePrice,
          })
        )
      }
    }
  }
}
